import imageCompression from "browser-image-compression";

const WEBP_OPTIONS = {
  maxSizeMB: 1,
  maxWidthOrHeight: 1920,
  useWebWorker: true,
  fileType: "image/webp",
  initialQuality: 0.85,
};

function webpFileName(originalName) {
  const base = (originalName || "image").replace(/\.[^.]+$/, "");
  return `${base}.webp`;
}

export async function convertToWebp(file) {
  if (!file || !(file instanceof Blob)) {
    return file;
  }

  const type = (file.type || "").toLowerCase();
  if (type === "image/webp") {
    return file;
  }
  if (type === "image/gif") {
    return file;
  }
  if (!type.startsWith("image/")) {
    return file;
  }

  try {
    const compressed = await imageCompression(file, WEBP_OPTIONS);
    return new File([compressed], webpFileName(file.name), {
      type: "image/webp",
      lastModified: Date.now(),
    });
  } catch (error) {
    console.warn("WebP conversion failed, using original file.", error);
    return file;
  }
}
